import { Action, createReducer, on } from '@ngrx/store';
import { SuperAdminHomeActions } from './superadmin-home.actions';
import {
  superAdminHomeInitialState,
  SuperAdminHomeState,
} from './superadmin-home.state';

const _superAdminHomeReducer = createReducer(
  superAdminHomeInitialState(),

  /**
   * Reducers For Get All Clients
   */
  on(SuperAdminHomeActions.getAllCustomers, (state) => {
    return {
      ...state,
      allCustomers: {
        loading: true,
      },
    };
  }),
  on(SuperAdminHomeActions.getAllCustomersSuccess, (state, { users }) => {
    return {
      ...state,
      allCustomers: {
        loading: false,
        data: users.data,
      },
    };
  }),
  on(SuperAdminHomeActions.getAllCustomersFailure, (state, { failure }) => {
    return {
      ...state,
      allCustomers: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Get All Clients
   */
  on(SuperAdminHomeActions.getAllActiveUsers, (state) => {
    return {
      ...state,
      allActiveUsers: {
        loading: true,
      },
    };
  }),
  on(SuperAdminHomeActions.getAllActiveUsersSuccess, (state, { users }) => {
    return {
      ...state,
      allActiveUsers: {
        loading: false,
        data: users.data,
      },
    };
  }),
  on(SuperAdminHomeActions.getAllActiveUsersFailure, (state, { failure }) => {
    return {
      ...state,
      allActiveUsers: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Get All Notification
   */
  on(SuperAdminHomeActions.getNotifications, (state) => {
    return {
      ...state,
      notifications: {
        loading: true,
      },
    };
  }),
  on(
    SuperAdminHomeActions.getNotificationsSuccess,
    (state, { notifications }) => {
      return {
        ...state,
        notifications: {
          loading: false,
          data: notifications.data,
        },
      };
    }
  ),
  on(SuperAdminHomeActions.getNotificationsFailure, (state, { failure }) => {
    return {
      ...state,
      notifications: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Get All Notification
   */
  on(SuperAdminHomeActions.markAsReadNotification, (state) => {
    return {
      ...state,
      notifications: {
        loading: true,
      },
    };
  }),
  on(
    SuperAdminHomeActions.markAsReadNotificationSuccess,
    (state, { response }) => {
      return {
        ...state,
        notifications: {
          loading: false,
          data: response.data,
        },
      };
    }
  ),
  on(
    SuperAdminHomeActions.markAsReadNotificationFailure,
    (state, { failure }) => {
      return {
        ...state,
        notifications: {
          loading: false,
          failure: failure,
        },
      };
    }
  ),
  /**
   * Get Notifications Count
   */
  on(SuperAdminHomeActions.getNotificationsCount, (state) => {
    return {
      ...state,
      notificationsCount: {
        loading: true,
      },
    };
  }),
  on(
    SuperAdminHomeActions.getNotificationsCountSuccess,
    (state, { response }) => {
      return {
        ...state,
        notificationsCount: {
          loading: false,
          data: response.data,
        },
      };
    }
  ),
  on(
    SuperAdminHomeActions.getNotificationsCountFailure,
    (state, { failure }) => {
      return {
        ...state,
        notificationsCount: {
          loading: false,
          failure: failure,
        },
      };
    }
  )
);

export function superAdminHomeReducer(
  state: SuperAdminHomeState | undefined,
  action: Action
) {
  return _superAdminHomeReducer(state, action);
}
